






import Vue from 'vue'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import store from '../store'

export default Vue.extend({
  name: 'App',
  created () {
    let vm = this
    store.dispatch('setBrowser')
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        store.commit('askLogin', false)
        store.commit('setUser', user)
        if (vm.$route.name === 'index') {
          vm.$router.replace({ name: 'main' })
        }
      } else {
        store.commit('askLogin', true)
        store.commit('setUser', {})
        if (vm.$route.name === 'main') {
          vm.$router.replace({ name: 'index' })
        }
      }
    })
  }
})
